module.exports = __webpack_public_path__ + "ar.4f098aa5.svg";